import { useEffect } from "react";
import { useToast } from "@salesapp/ui";
import { subscribeSaved } from "./savedToast";

/** Turns notifySaved() into the shared success toast. Mount once inside ToastProvider. */
export function SavedToaster() {
  const toast = useToast();
  useEffect(() => subscribeSaved((message) => toast.show(message, "success")), [toast]);
  return null;
}
